import { useCallback } from "react";
import {
  peticionGet,
  peticionPost,
  peticionPut,
  peticionDelete,
} from "Componentes/ComponenteAxios";

export const useAsignacionPlantillaApi = () => {
  const getTrabajadores = useCallback(async () => {
    const { peticion, error } = await peticionGet("/trabajadores");
    if (error) throw error;
    return peticion?.datos ?? peticion;
  }, []);

  const getPlantillas = useCallback(async () => {
    const { peticion, error } = await peticionGet("/plantillasAnuales");
    if (error) throw error;
    return peticion?.datos ?? peticion;
  }, []);

  const getSedes = useCallback(async () => {
    const { peticion, error } = await peticionGet("/sedes");
    if (error) throw error;
    return peticion?.datos ?? peticion;
  }, []);

  const getDepartamentosPorSede = useCallback(async (sedeId) => {
    if (!sedeId) return [];
    const { peticion, error } = await peticionGet(
      `/departamentos?sede_id=${sedeId}`
    );
    if (error) throw error;
    return peticion?.datos ?? peticion;
  }, []);

  // --- Crear asignación ---
  const crearAsignacion = useCallback(async (payload) => {
    console.log(payload);
    const { peticion, error } = await peticionPost(
      "/planificador/asignacion-plantilla",
      {
        id_usuario: payload.trabajador_id,
        nombre_usuario: payload.trabajador_nombre,
        id_plantilla: payload.plantilla_id,
        id_sede: payload.sede_id,
        id_departamento: payload.departamento_id,
        fecha_inicio: payload.fecha_inicio,
        fecha_fin: payload.fecha_fin,
      }
    );
    if (error) throw error;
    return peticion;
  }, []);

  const getAsignaciones = useCallback(async () => {
    const { peticion, error } = await peticionGet(
      "/planificador/asignacion-plantilla"
    );
    console.log(peticion);
    if (error) throw error;
    return peticion?.datos ?? peticion;
  }, []);
  // --- Aplicar ---
  const aplicarAsignacion = useCallback(async (id) => {
    const { peticion, error } = await peticionPost(
      `/planificador/asignacion-plantilla/${id}/aplicar`
    );
    if (error) throw error;
    return peticion;
  }, []);

  // --- Desaplicar ---
  const desaplicarAsignacion = useCallback(async (id) => {
    const { peticion, error } = await peticionPost(
      `/planificador/asignacion-plantilla/${id}/desaplicar`
    );
    if (error) throw error;
    return peticion;
  }, []);

  // --- Eliminar ---
  const eliminarAsignacion = useCallback(async (id) => {
    const { peticion, error } = await peticionDelete(
      `/planificador/asignacion-plantilla/${id}`
    );
    if (error) throw error;
    return peticion;
  }, []);

  return {
    getTrabajadores,
    getPlantillas,
    getSedes,
    getDepartamentosPorSede,
    crearAsignacion,
    getAsignaciones,
    aplicarAsignacion,
    desaplicarAsignacion,
    eliminarAsignacion,
  };
};
